export enum CALL_SOURCE {
  VNPT = 'vnpt',
  APP = 'app',
  WEB = 'web'
}
